import { useWhiteLabelContext } from 'components/white-label/context';
import _ from 'lodash';
import Head from 'next/head';

interface IPageTitleProps {
  title: string;
  defaultTitle?: string;
  suffix?: string;
}

/** @deprecated Prefer the `Layout` component's `pageTitle` prop instead. */
export const PageTitle = ({
  title,
  defaultTitle = '',
  suffix,
}: IPageTitleProps) => {
  const { organizationName, faviconHref } = useWhiteLabelContext();

  const fullTitle = _.chain([title ?? defaultTitle, suffix ?? organizationName])
    .compact()
    .join(' | ')
    .value();

  return (
    <Head>
      <title>{fullTitle}</title>
      <link rel="icon" href={faviconHref} />
    </Head>
  );
};
